import { DATE_FOR_API_FORMAT, MC_DEVICE_TYPE, MC_SOFTWARE_TYPE } from 'config/const';
import { ROLES_ID } from 'config/roles';
import { apiUrl } from 'config/settings';

export function temperatureReportControllers(controllers = [], user) {
  return controllers.flatMap(parent => {
    if (parent.softwareType === MC_SOFTWARE_TYPE.B2_0) return [parent];
    if (parent.softwareType !== MC_SOFTWARE_TYPE.B2_2) return [];
    const assigned = user?.department?.mcList;
    if ([ROLES_ID.DEPARTMENT_MANAGER, ROLES_ID.EMPLOYEE].includes(user?.userRole) &&
        assigned?.length && !assigned.some(id => String(id) === String(parent.id))) return [];
    // Disabled sensors retain their historical measurements until they are deleted.
    return (parent.sensorUnits || []).filter(sensor => !sensor.deletionPending).map(sensor => ({
      id: sensor.id, guid: `b22:${sensor.id}`, name: sensor.name,
      parentId: parent.id, parentGuid: parent.guid, isB22Sensor: true,
      softwareType: MC_SOFTWARE_TYPE.B2_2, deviceType: sensor.deviceType || MC_DEVICE_TYPE.REFRIGERATION,
      area: parent.area,
    }));
  });
}

export function temperatureReportRequest(controller, start, end) {
  if (controller.isB22Sensor) return {
    url: `/mc/${controller.parentId}/b22/${controller.id}/reports`,
    config: { params: { start: start.toISOString(), end: end.toISOString() } },
  };
  return { url: `${apiUrl}/reports/temp/${controller.guid}/${start.format(DATE_FOR_API_FORMAT)}/${end.format(DATE_FOR_API_FORMAT)}` };
}
